import { message, Input, Select, Upload, Popconfirm, Row, Col, Alert, Form as FormInitial, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  InputItem,
  InputNumberItem,
  ButtonItem,
  ErrorItem,
  TextAreaItem,
  TableItem,
  dineroDisabledMask,
  TourItem,
  SwitchItem,
} from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, PictureOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import AsistenteDepreciacionLISR from "../../../../Components/AsistenteDepreciacionLISR";
import moment from "moment";

const { Option } = Select;

const CUENTAS = [
  { campo: "cuentaActivoId", flag: "generarCuentaHijaActivo", label: "Cuenta del Activo" },
  { campo: "cuentaDepreciacionAcumuladaId", flag: "generarCuentaHijaDepreciacionAcumulada", label: "Cuenta de Depreciación Acumulada" },
  { campo: "cuentaCostoGastoActivoId", flag: "generarCuentaHijaCostoGastoActivo", label: "Cuenta de Costo o Gasto" },
  { campo: "cuentaUtilidadActivoId", flag: "generarCuentaHijaUtilidadActivo", label: "Cuenta de Utilidad de Activo" },
  { campo: "cuentaPerdidaActivoId", flag: "generarCuentaHijaPerdidaActivo", label: "Cuenta de Pérdida de Activo" },
];

const TIPOS_MOVIMIENTO = {
  801: { label: "Alta", color: "green" },
  802: { label: "Depreciación", color: "blue" },
  803: { label: "Venta", color: "purple" },
  804: { label: "Baja", color: "red" },
};

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class EditarActivoFijo extends Component {
  formRef = React.createRef();
  refDatosGenerales = React.createRef();
  refTabs = React.createRef();

  state = {
    loading: false,
    openTour: false,
    openAsistenteDepreciacion: false,
    objetoTiposDeActivo: null,
    todosTiposDeActivo: [],
    tipoDeActivoSeleccionado: null,
    objetoUnidades: null,
    objetoCuentaContable: null,
    todasCuentasContables: [],
    objetoImpuestos: null,
    objetoRetenciones: null,
    modalAgregarCuentaContable: false,
    utilizado: false,
    archivosPrincipal: [],
    archivosTecnica: [],
    archivosFotos: [],
    historialCostos: [],
    unidades: [],
    movimientos: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  cerrarEditarActivoFijo(codigo) {
    this.props.cerrarEditarActivoFijo(codigo);
    this.formRef.current.resetFields();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post("activosFijos/selectTiposDeActivo", { empresaId: this.props.empresaId, valor: 3 }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({
            todosTiposDeActivo: res.data,
            objetoTiposDeActivo: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
          });
        }
      });
    await axios
      .post("unidades/selectTodasUnidades", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ objetoUnidades: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>) });
        }
      });
    await axios
      .post("cuentascontables/selectCuentasContablesFinales", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((v) => (
              <Option value={v._id} key={v._id}>{cuentaMask(v.nivel1 + v.nivel2 + v.nivel3 + v.nivel4 + v.nivel5) + " - " + v.descripcion}</Option>
            )),
          });
        }
      });
    // Lista completa (no solo las cuentas finales) para poder mostrar el nombre
    // de la cuenta del Tipo de Activo: si esa cuenta ya generó hijas dejó de ser
    // final y no viene en selectCuentasContablesFinales.
    await axios
      .post("cuentascontables/selectTodasCuentasContables", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ todasCuentasContables: res.data });
      });
    await axios
      .post("impuestos/selectTodosImpuestos", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ objetoImpuestos: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>) });
        }
      });
    await axios
      .post("retenciones/selectTodasRetenciones", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ objetoRetenciones: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>) });
        }
      });
    await axios
      .post("activosFijos/datosActivoFijo", { empresaId: this.props.empresaId, insumoId: this.props.id }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error, no se encontró información del Activo");
        } else {
          if (res.data.utilizado) {
            message.info("No se puede modificar la configuración de depreciación/cuentas ya que este Activo ya tiene unidades dadas de alta");
          }
          const archivosPrincipal = (res.data.archivosPrincipal || []).map((f, i) => ({ uid: `p${i}`, name: f.name, status: "done", url: "../" + f.url, thumbUrl: "../" + f.url }));
          const archivosTecnica = (res.data.archivosTecnica || []).map((f, i) => ({ uid: `t${i}`, name: f.name, status: "done", url: "../" + f.url, thumbUrl: "../" + f.url }));
          const archivosFotos = (res.data.archivosFotos || []).map((f, i) => ({ uid: `f${i}`, name: f.name, status: "done", url: "../" + f.url, thumbUrl: "../" + f.url }));
          this.formRef.current.setFieldsValue({ ...res.data, archivosPrincipal, archivosTecnica, archivosFotos });
          this.setState({
            utilizado: res.data.utilizado,
            tipoDeActivoSeleccionado:
              this.state.todosTiposDeActivo.find(
                (v) => res.data.familiaId && v._id.toString() === res.data.familiaId.toString()
              ) || null,
            archivosPrincipal,
            archivosTecnica,
            archivosFotos,
            historialCostos: res.data.historialCostos || [],
          });
        }
      });
    await axios
      .post("activosFijos/selectUnidadesPorActivo", { empresaId: this.props.empresaId, insumoId: this.props.id, valor: 4 }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ unidades: res.data });
      });
    await axios
      .post("activosFijos/selectMovimientosActivosFijos", { empresaId: this.props.empresaId, insumoId: this.props.id, page: 1, pageSize: 100 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ movimientos: res.data.data || [] });
      });
    this.setState({ loading: false });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    const archivosPrincipal = this.state.archivosPrincipal.map((f) => ({ name: f.name, url: f.preview || f.url }));
    const archivosTecnica = this.state.archivosTecnica.map((f) => ({ name: f.name, url: f.preview || f.url }));
    const archivosFotos = this.state.archivosFotos.map((f) => ({ name: f.name, url: f.preview || f.url }));
    axios
      .post(
        "activosFijos/editarActivoFijo",
        { empresaId: this.props.empresaId, insumoId: this.props.id, ...values, archivosPrincipal, archivosTecnica, archivosFotos },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha editado el Activo");
          this.formRef.current.resetFields();
          this.cerrarEditarActivoFijo(res.data.codigo);
        } else {
          message.error(res.data.message || "Hubo un error y el Activo no se editó");
        }
      });
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  handlePreview = async (file) => {
    let preview = file.url || file.preview;
    if (!preview) {
      preview = await getBase64(file.originFileObj || file);
      file.preview = preview;
    }
    this.setState({ previewVisible: true, previewImage: preview, previewTitle: file.name || "" });
  };

  async customRequestPrincipal(e) {
    const file = e.file;
    const preview = await getBase64(file);
    this.setState({ archivosPrincipal: [...this.state.archivosPrincipal, { uid: file.uid || `${Date.now()}`, name: file.name, status: "done", preview, thumbUrl: preview, originFileObj: file }] });
    e.onSuccess("ok");
  }
  onRemoveFilePrincipal(file) {
    this.setState({ archivosPrincipal: this.state.archivosPrincipal.filter((f) => f.uid !== file.uid) });
  }
  async customRequestFicha(e) {
    const file = e.file;
    const preview = await getBase64(file);
    this.setState({ archivosTecnica: [...this.state.archivosTecnica, { uid: file.uid || `${Date.now()}`, name: file.name, status: "done", preview, thumbUrl: preview, originFileObj: file }] });
    e.onSuccess("ok");
  }
  onRemoveFileFicha(file) {
    this.setState({ archivosTecnica: this.state.archivosTecnica.filter((f) => f.uid !== file.uid) });
  }
  async customRequestFotos(e) {
    const file = e.file;
    const preview = await getBase64(file);
    this.setState({ archivosFotos: [...this.state.archivosFotos, { uid: file.uid || `${Date.now()}`, name: file.name, status: "done", preview, thumbUrl: preview, originFileObj: file }] });
    e.onSuccess("ok");
  }
  onRemoveFileFotos(file) {
    this.setState({ archivosFotos: this.state.archivosFotos.filter((f) => f.uid !== file.uid) });
  }

  onChangeTipoDeActivo(familiaId) {
    const tipoDeActivo = this.state.todosTiposDeActivo.find((value) => value._id.toString() === familiaId.toString());
    this.setState({ tipoDeActivoSeleccionado: tipoDeActivo || null });
    // Las cuentas resueltas con el Tipo de Activo anterior ya no aplican: se
    // limpian para que vuelvan a heredarse del tipo recién elegido.
    const cuentasLimpias = {};
    CUENTAS.forEach(({ campo }) => {
      cuentasLimpias[campo] = undefined;
    });
    this.formRef.current.setFieldsValue(cuentasLimpias);
  }

  nombreCuentaContable(cuentaId) {
    if (!cuentaId) return null;
    const cuenta = this.state.todasCuentasContables.find((value) => value._id.toString() === cuentaId.toString());
    if (!cuenta) return null;
    return cuentaMask(cuenta.nivel1 + cuenta.nivel2 + cuenta.nivel3 + cuenta.nivel4 + cuenta.nivel5) + " - " + cuenta.descripcion;
  }

  // Pista viva de lo que va a pasar con esta cuenta. Quien decide si se genera
  // hija o se comparte es el Tipo de Activo — aquí solo se menciona.
  renderPistaCuenta({ campo, flag, cuentaCapturada }) {
    if (cuentaCapturada) {
      return (
        <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.45)", marginTop: 2 }}>
          Se usará esta cuenta tal cual; no se generará ninguna subcuenta.
        </div>
      );
    }
    const tipoDeActivo = this.state.tipoDeActivoSeleccionado;
    if (!tipoDeActivo) return null;
    const nombreCuenta = this.nombreCuentaContable(tipoDeActivo[campo]);
    if (!nombreCuenta) {
      return (
        <div style={{ fontSize: 12, color: "#cf1322", marginTop: 2 }}>
          El Tipo de Activo no tiene esta cuenta configurada; si dejas el campo vacío, el Activo quedará sin ella.
        </div>
      );
    }
    return (
      <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.45)", marginTop: 2 }}>
        {tipoDeActivo[flag]
          ? `Vacío → se generará una subcuenta propia de este Activo, colgada de ${nombreCuenta}.`
          : `Vacío → usará ${nombreCuenta}, compartida con los demás Activos de este tipo.`}
      </div>
    );
  }

  renderCuentaOverride({ campo, flag, label }) {
    return (
      <FormItem
        label={label}
        margin
        key={campo}
        tooltip={{ title: `Vacío = hereda de su Tipo de Activo (y si ese tipo genera cuenta hija, se le crea su propia subcuenta). Si capturas una cuenta aquí, se usa esa exactamente y no se genera ninguna subcuenta.` }}
      >
        <FormItem noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const cuentaCapturada = !!getFieldValue(campo);
            return (
              <>
                <Input.Group compact>
                  <FormItem name={campo} noStyle>
                    <SelectItem placeholder="Vacío = hereda del Tipo de Activo" width="85%" allowClear disabled={this.state.utilizado}>
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                  <ButtonItem blanco disabled={this.state.utilizado} icon={<PlusOutlined />} style={{ width: "13%", marginLeft: 5 }} onClick={this.abrirAgregarCuentaContable.bind(this)} />
                </Input.Group>
                {this.renderPistaCuenta({ campo, flag, cuentaCapturada })}
              </>
            );
          }}
        </FormItem>
      </FormItem>
    );
  }

  renderUpload({ fileListKey, customRequest, onRemove, label, sinRestriccionTipo }) {
    return (
      <Upload
        listType="picture-card"
        itemRender={(originNode, file) => (
          <div style={{ display: "inline-block", textAlign: "center", marginRight: 8 }}>
            {originNode}
            <div style={{ fontSize: 12, marginTop: 6, maxWidth: 104, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{file.name}</div>
          </div>
        )}
        showUploadList={{
          showRemoveIcon: true,
          showPreviewIcon: true,
          removeIcon: (file) => (
            <Popconfirm title="Seguro que quieres eliminar el archivo" onConfirm={() => this[onRemove](file)} okText="Si" cancelText="No">
              <DeleteOutlined onClick={(e) => e.preventDefault()} />
            </Popconfirm>
          ),
        }}
        fileList={this.state[fileListKey]}
        customRequest={this[customRequest].bind(this)}
        onPreview={this.handlePreview}
        multiple={fileListKey !== "archivosPrincipal"}
        maxCount={fileListKey === "archivosPrincipal" ? 1 : undefined}
        accept={sinRestriccionTipo ? undefined : "image/*"}
        beforeUpload={
          sinRestriccionTipo
            ? undefined
            : (file) => {
              const isImage = ["image/jpeg", "image/png", "image/webp"].includes(file.type);
              const isLt5M = file.size / 1024 / 1024 < 5;
              if (!isImage) {
                message.error(`${file.name} no es un tipo de imagen válido (JPEG/PNG/WEBP)`);
                return Upload.LIST_IGNORE;
              }
              if (!isLt5M) {
                message.error(`${file.name} excede el tamaño máximo de 5MB`);
                return Upload.LIST_IGNORE;
              }
              return true;
            }
        }
      >
        <div>
          <PictureOutlined />
          <div style={{ marginTop: 8 }}>{label}</div>
        </div>
      </Upload>
    );
  }

  render() {
    const relaciones = [];
    const vistos = new Set();
    this.state.unidades.forEach((u) => {
      if (u.proveedor && !vistos.has("prov:" + u.proveedor)) {
        vistos.add("prov:" + u.proveedor);
        relaciones.push({ tipo: "Proveedor", valor: u.proveedor });
      }
      if (u.fabricante && !vistos.has("fab:" + u.fabricante)) {
        vistos.add("fab:" + u.fabricante);
        relaciones.push({ tipo: "Fabricante", valor: u.fabricante });
      }
    });

    const allTabs = [
      {
        key: "depreciacion",
        label: "Depreciación",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="CONFIGURACIÓN DE DEPRECIACIÓN (OVERRIDES)" lg="100%">
            <Row gutter={[16, 8]}>
              <Col xs={24} md={12}>
                <FormItem name="metodoDepreciacion" label="Método de Depreciación" margin tooltip={{ title: "Método para calcular la depreciación de cada periodo. Fórmula de Línea Recta: (Costo − Valor Residual) × Depreciación Anual %." }}>
                  <SelectItem placeholder="Hereda del Tipo de Activo" allowClear disabled={this.state.utilizado}>
                    <Option value={1}>Línea recta</Option>
                  </SelectItem>
                </FormItem>
                <FormItem name="frecuenciaDepreciacion" label="Frecuencia de Depreciación" margin tooltip={{ title: "Cada cuánto se deprecia: Mensual, Bimestral, Trimestral, Semestral o Anual." }}>
                  <SelectItem placeholder="Hereda del Tipo de Activo" allowClear disabled={this.state.utilizado}>
                    <Option value={1}>Mensual</Option>
                    <Option value={2}>Bimestral</Option>
                    <Option value={3}>Trimestral</Option>
                    <Option value={4}>Semestral</Option>
                    <Option value={5}>Anual</Option>
                  </SelectItem>
                </FormItem>
                <FormItem name="porcentajeDepreciacionAnual" label="Depreciación Anual (%)" margin tooltip={{ title: "Qué porcentaje del costo (menos el valor residual) se deprecia cada año, ej. 10% anual = 10 años de vida útil." }}>
                  <InputNumberItem placeholder="Hereda del Tipo de Activo" porcentaje min={0.01} max={100} disabled={this.state.utilizado} />
                </FormItem>
                <FormItem name="valorResidualPorcentaje" label="Valor Residual" margin tooltip={{ title: "% del costo que nunca se deprecia." }}>
                  <InputNumberItem placeholder="Hereda del Tipo de Activo" porcentaje min={0} max={100} disabled={this.state.utilizado} />
                </FormItem>
              </Col>
              <Col xs={24} md={12}>
                <FormItem name="prefijoSerieActivo" label="Prefijo de Serie" margin pattern tooltip={{ title: "Prefijo del folio de cada unidad, ej. 'MOB-'." }}>
                  <InputItem placeholder="Hereda del Tipo de Activo" disabled={this.state.utilizado} />
                </FormItem>
                <FormItem name="longitudFolioActivo" label="Longitud de Folio" margin tooltip={{ title: "Dígitos del consecutivo, rellenado con ceros." }}>
                  <InputNumberItem placeholder="Hereda del Tipo de Activo" min={1} max={10} disabled={this.state.utilizado} />
                </FormItem>
                <FormItem name="siguienteFolioActivo" label="Contador propio (inicia en)" margin tooltip={{ title: "Si se captura, este Activo usa su propio consecutivo de folio." }}>
                  <InputNumberItem placeholder="Compartir contador del Tipo de Activo" min={1} disabled={this.state.utilizado} />
                </FormItem>
              </Col>
            </Row>
            <div style={{ marginTop: 8 }}>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 12 }}
                message="Cómo se resuelve cada cuenta"
                description={
                  <span>
                    Si dejas la cuenta <strong>vacía</strong>, el Activo hereda la de su Tipo de Activo: si ese tipo está marcado para <strong>generar cuenta hija</strong>, se le crea automáticamente su propia subcuenta; si no, comparte la cuenta del tipo tal cual.
                    Si <strong>capturas</strong> una cuenta aquí, se usa esa exactamente y no se genera ninguna subcuenta.
                  </span>
                }
              />
              {CUENTAS.map((c) => this.renderCuentaOverride(c))}
            </div>
          </DynamicCardForm>
        ),
      },
      {
        key: "archivoGrafico",
        label: "Archivo Gráfico",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="ARCHIVO GRÁFICO" lg="100%">
            <Row gutter={[12, 4]}>
              <Col flex="1">{this.renderUpload({ fileListKey: "archivosPrincipal", customRequest: "customRequestPrincipal", onRemove: "onRemoveFilePrincipal", label: "Foto Principal" })}</Col>
              <Col flex="1">{this.renderUpload({ fileListKey: "archivosTecnica", customRequest: "customRequestFicha", onRemove: "onRemoveFileFicha", label: "Ficha Técnica", sinRestriccionTipo: true })}</Col>
              <Col flex="1">{this.renderUpload({ fileListKey: "archivosFotos", customRequest: "customRequestFotos", onRemove: "onRemoveFileFotos", label: "Fotos" })}</Col>
            </Row>
          </DynamicCardForm>
        ),
      },
      {
        key: "existencias",
        label: "Existencias",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="EXISTENCIAS (UNIDADES FÍSICAS)" lg="100%">
            <TableItem
              size="small"
              pagination={false}
              dataSource={this.state.unidades}
              columns={[
                { title: "Serie / Folio", dataIndex: "serieNumero", key: "serieNumero" },
                { title: "Fecha Adquisición", dataIndex: "fechaAdquisicion", key: "fechaAdquisicion", render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "-") },
                { title: "Ubicación", dataIndex: "ubicacionFisica", key: "ubicacionFisica" },
                { title: "Costo", dataIndex: "costo", key: "costo", render: (v) => dineroDisabledMask(v) },
                { title: "Valor en Libros", dataIndex: "valorEnLibros", key: "valorEnLibros", render: (v) => dineroDisabledMask(v) },
                {
                  title: "Estado", key: "estado", render: (v, record) => record.dadoDeBaja
                    ? <Tag color={record.tipoDisposicion === "venta" ? "blue" : "red"} className="square-tag">{record.tipoDisposicion === "venta" ? "Vendido" : "De baja"}</Tag>
                    : <Tag color="green" className="square-tag">Vigente</Tag>,
                },
              ]}
            />
          </DynamicCardForm>
        ),
      },
      {
        key: "kardex",
        label: "Kardex",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="KARDEX (MOVIMIENTOS)" lg="100%">
            <TableItem
              size="small"
              pagination={false}
              dataSource={this.state.movimientos}
              columns={[
                { title: "Folio", dataIndex: "serieNumero", key: "serieNumero" },
                { title: "Fecha", dataIndex: "fecha", key: "fecha", render: (v) => (v ? moment(v).format("DD/MM/YYYY HH:mm") : "-") },
                {
                  title: "Tipo", dataIndex: "tipoMovimiento", key: "tipoMovimiento", render: (v) => {
                    const c = TIPOS_MOVIMIENTO[v] || { label: "—", color: "default" };
                    return <Tag color={c.color} className="square-tag">{c.label}</Tag>;
                  },
                },
                { title: "Concepto", dataIndex: "concepto", key: "concepto" },
                { title: "Monto", dataIndex: "costoTotal", key: "costoTotal", render: (v) => dineroDisabledMask(v) },
              ]}
            />
          </DynamicCardForm>
        ),
      },
      {
        key: "historialCostos",
        label: "Historial de Costos",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="HISTORIAL DE COSTO DE REFERENCIA" lg="100%">
            <TableItem
              size="small"
              pagination={false}
              dataSource={this.state.historialCostos}
              columns={[
                { title: "Fecha", dataIndex: "fecha", key: "fecha", render: (v) => (v ? moment(v).format("DD/MM/YYYY HH:mm") : "-") },
                { title: "Costo", dataIndex: "costo", key: "costo", render: (v) => dineroDisabledMask(v) },
              ]}
            />
          </DynamicCardForm>
        ),
      },
      {
        key: "relaciones",
        label: "Relaciones",
        forceRender: true,
        customContent: (
          <DynamicCardForm title="PROVEEDORES Y FABRICANTES REGISTRADOS" lg="100%">
            <div style={{ marginBottom: 8, fontSize: 12, color: "#8c8c8c" }}>
              Resumen de los proveedores y fabricantes capturados en las unidades físicas de este Activo (a diferencia de Insumos, un Activo Fijo no tiene relaciones de compra automáticas — esto es solo informativo).
            </div>
            <TableItem
              size="small"
              pagination={false}
              dataSource={relaciones}
              columns={[
                { title: "Tipo", dataIndex: "tipo", key: "tipo" },
                { title: "Valor", dataIndex: "valor", key: "valor" },
              ]}
            />
          </DynamicCardForm>
        ),
      },
    ];

    const steps = [
      { title: "Editar Activo", description: "Aquí ajustas los datos generales, impuestos/retenciones, overrides de depreciación e imágenes de este Activo, y consultas su historial (existencias, kardex, costos).", target: null },
      { title: "Datos Generales", description: "Descripción, unidad, Tipo de Activo e impuestos/retenciones.", target: () => this.refDatosGenerales.current },
      { title: "Pestañas: Depreciación, Archivo Gráfico, Existencias, Kardex, Historial, Relaciones", description: "Si el Activo ya tiene unidades dadas de alta, sus cuentas y reglas de depreciación quedan bloqueadas (para no romper la contabilidad ya generada) — pero puedes consultar aquí sus unidades, movimientos y costo histórico haciendo clic en cada pestaña.", target: () => this.refTabs.current },
    ];

    return (
      <>
        <ModalItem
          title={
            <span>
              Editar Activo{" "}
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openTour: true })}>¿Cómo funciona?</ButtonItem>
              <ButtonItem type="link" size="small" blanco disabled={this.state.utilizado} onClick={() => this.setState({ openAsistenteDepreciacion: true })}>Asistente de Depreciación (Ley ISR)</ButtonItem>
            </span>
          }
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEditarActivoFijo.bind(this)}
          paddingTop
          width={1000}
        >
          <Form
            ref={this.formRef}
            name="editarActivoFijo"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Editar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <div ref={this.refDatosGenerales}>
              <GeneralFormLayout
                cards={[
                  {
                    title: "DATOS GENERALES",
                    lg: 24,
                    content: (
                      <Row gutter={[16, 8]}>
                        <Col xs={24} lg={17}>
                          <FormItem name="familiaId" label="Tipo de Activo" required margin tooltip={{ title: "Categoría contable del Activo." }}>
                            <SelectItem placeholder="Tipo de Activo" disabled={this.state.utilizado} onChange={this.onChangeTipoDeActivo.bind(this)}>
                              {this.state.objetoTiposDeActivo}
                            </SelectItem>
                          </FormItem>
                          <FormItem name="descripcion" label="Descripción" required max={150} margin pattern>
                            <InputItem placeholder="Ej. Laptop Dell Latitude" />
                          </FormItem>
                          <FormItem name="descripcionLarga" label="Descripción Larga" required margin pattern>
                            <TextAreaItem placeholder="Descripción detallada" rows={2} />
                          </FormItem>
                          <FormItem label="Unidad" margin>
                            <Input.Group compact>
                              <FormItem name="unidadId" required noStyle>
                                <SelectItem placeholder="Unidad" width="100%">{this.state.objetoUnidades}</SelectItem>
                              </FormItem>
                            </Input.Group>
                          </FormItem>
                          <FormItem name="clave" label="Clave" margin pattern>
                            <InputItem placeholder="Clave" />
                          </FormItem>
                          <FormItem name="codigoBarras" label="Código de Barras" margin pattern>
                            <InputItem placeholder="Código de barras" />
                          </FormItem>
                          <FormItem name="costo" label="Costo de Referencia" margin tooltip={{ title: "Costo de referencia/catálogo. Cambiarlo aquí queda registrado en el Historial de Costos, pero NO afecta la depreciación de unidades ya dadas de alta." }}>
                            <InputNumberItem placeholder="Costo de referencia" dinero />
                          </FormItem>
                          <FormItem
                            name="compra"
                            label="Permitir Compra"
                            margin
                            valuePropName="checked"
                            labelCol={{ span: 19 }}
                            wrapperCol={{ span: 5 }}
                            tooltip={{ title: "Permite comprar este Activo en Órdenes de Compra, Facturas sin Orden de Compra, Caja Chica y Remisiones. Al recibirlo se da de alta una unidad (con su folio y su etiqueta) por cada pieza recibida. Además hay que relacionarlo con el proveedor en Proveedores → Relación Insumo - Proveedor." }}
                          >
                            <SwitchItem />
                          </FormItem>
                          <FormItem
                            name="venta"
                            label="Permitir Venta"
                            margin
                            valuePropName="checked"
                            labelCol={{ span: 19 }}
                            wrapperCol={{ span: 5 }}
                            tooltip={{ title: "Normalmente se deja apagado. Un activo fijo se vende desde Inventario de Activos → Vender Activo, que es el flujo que calcula la utilidad o pérdida contra el valor en libros y cancela su depreciación acumulada. Si lo prendes, el Activo también aparecerá como renglón normal en ventas, listas de precios y punto de venta — y venderlo por ahí NO hace esos asientos." }}
                          >
                            <SwitchItem />
                          </FormItem>
                        </Col>
                        <Col xs={24} lg={7}>
                          <div style={{ textAlign: "center", marginBottom: 8, fontWeight: 600, fontSize: 13 }}>IMPUESTOS</div>
                          <FormInitial.List name="impuestos">
                            {(fields, { add, remove }) => (
                              <>
                                <div style={{ maxHeight: 140, overflowY: "auto", paddingRight: 4 }}>
                                  {fields.map(({ name }, arrayKey) => (
                                    <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                      <Col flex="1">
                                        <FormItem name={[name, "impuestoId"]} required noStyle>
                                          <SelectItem width="100%" placeholder="Impuesto">{this.state.objetoImpuestos}</SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col flex="28px"><DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} /></Col>
                                    </Row>
                                  ))}
                                </div>
                                <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block>Agregar</ButtonItem>
                              </>
                            )}
                          </FormInitial.List>
                          <div style={{ textAlign: "center", margin: "12px 0 8px", fontWeight: 600, fontSize: 13 }}>RETENCIONES</div>
                          <FormInitial.List name="retenciones">
                            {(fields, { add, remove }) => (
                              <>
                                <div style={{ maxHeight: 140, overflowY: "auto", paddingRight: 4 }}>
                                  {fields.map(({ name }, arrayKey) => (
                                    <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                      <Col flex="1">
                                        <FormItem name={[name, "retencionId"]} required noStyle>
                                          <SelectItem width="100%" placeholder="Retención">{this.state.objetoRetenciones}</SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col flex="28px"><DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} /></Col>
                                    </Row>
                                  ))}
                                </div>
                                <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block>Agregar</ButtonItem>
                              </>
                            )}
                          </FormInitial.List>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
              />
            </div>
            <div ref={this.refTabs}>
              <TabbedDynamicTable
                formInstance={this.formRef}
                defaultActiveKey="depreciacion"
                tabs={allTabs}
              />
            </div>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <TourItem open={this.state.openTour} onClose={() => this.setState({ openTour: false })} steps={steps} />
        <AsistenteDepreciacionLISR
          visible={this.state.openAsistenteDepreciacion}
          onClose={() => this.setState({ openAsistenteDepreciacion: false })}
          onAplicar={({ porcentaje, metodo }) =>
            this.formRef.current.setFieldsValue({
              porcentajeDepreciacionAnual: porcentaje,
              metodoDepreciacion: metodo,
            })
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarActivoFijo);
